import * as React from 'react';
import { useSelector } from 'react-redux';
import { getAllocatedResidentialComplexes } from '../../selectors';
import { ResidentialComplexesList as ResidentialComplexesListComponent } from '../../components/ResidentialComplexesList';
import { ResidentialComplexCard } from '../ResidentialComplexCard';
import { ShowMoreButton } from './ShowMoreButton';
import { PikPlusBlock } from '../PikPlusBlock';
import { checkPikPlusResidentialComplexes } from '../../utils/checkPikPlusResidentialComplexes';
import { DEFAULT_NUMBER_OF_COMPLEXES_PER_PAGE, PIK_PLUS_NUMBER_OF_COMPLEXES_PER_PAGE } from '../../settings';
import { ResidentialComplexCardWrapper } from '../../components/ResidentialComplexCardWrapper';

export function ResidentialComplexesList() {
  const residentialComplexes = useSelector(getAllocatedResidentialComplexes);

  const complexesNumber = checkPikPlusResidentialComplexes(residentialComplexes)
    ? PIK_PLUS_NUMBER_OF_COMPLEXES_PER_PAGE
    : DEFAULT_NUMBER_OF_COMPLEXES_PER_PAGE;
  const [showAll, setShowAll] = React.useState(false);
  const hasMoreComplexes = !showAll && residentialComplexes.length > complexesNumber;
  const complexesForRender = showAll ? residentialComplexes : residentialComplexes.slice(0, complexesNumber);
  const leftComplexes = residentialComplexes.length - complexesForRender.length;

  const handleShowMore = React.useCallback(() => setShowAll(true), []);

  return (
    <ResidentialComplexesListComponent
      complexesList={complexesForRender.map(complex =>
        complex.displayType === 'plus' ? (
          <PikPlusBlock key={complex.id} residentialComplexId={complex.id} />
        ) : (
          <ResidentialComplexCardWrapper key={complex.id}>
            <ResidentialComplexCard id={complex.id} />
          </ResidentialComplexCardWrapper>
        ),
      )}
      showMoreButton={hasMoreComplexes ? <ShowMoreButton onClick={handleShowMore} length={leftComplexes} /> : null}
    />
  );
}
